import { DialogPortalProps, Portal } from '@radix-ui/react-dialog';

import { cn } from '@/services/utils';

const DialogPortal = ({ className, useReactPortal, ...props }: DialogPortalProps & { useReactPortal: boolean }) => (
    useReactPortal ?
        <Portal className={cn(className)} {...props} /> :
        <div className={cn(className)} {...props} />
);

DialogPortal.displayName = Portal.displayName;

export { DialogPortal };
